var React = require('react');

function CircleMinusLight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M352 240C360.8 240 368 247.2 368 256C368 264.8 360.8 272 352 272H160C151.2 272 144 264.8 144 256C144 247.2 151.2 240 160 240H352zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 32C132.3 32 32 132.3 32 256C32 379.7 132.3 480 256 480C379.7 480 480 379.7 480 256C480 132.3 379.7 32 256 32z"}));
}

CircleMinusLight.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = CircleMinusLight;

CircleMinusLight.default = CircleMinusLight;
